export const wordInitials = (w: string): string[] =>
  w
    .toUpperCase()
    .split(' ')
    .map(n => n[0]);
